import { fromUtf8 } from '../../../utils/utf8.js';
export const dataToExecData = (action, data) => {
    return { [action]: data };
};
export class ExecArgBase {
    params;
    constructor(params) {
        this.params = params;
    }
    toJSON() {
        return fromUtf8(JSON.stringify(this.params));
    }
    toExecJSON() {
        return fromUtf8(JSON.stringify(this.toExecData()));
    }
}
